








import Vue from "vue";
const maxSingleSegmentSMSLengthGSM = 160;
const maxMultiSegmentSMSLengthGSM = 153;
const maxSingleSegmentSMSLengthUCS2 = 70;
const maxMultiSegmentSMSLengthUCS2 = 67;
const GSMCharacters =
  "@Δ\u00200¡P¿p£_!1AQaq$Φ\"2BRbr¥Γ#3CScsèΛ¤4DTdtéΩ%5EUeuùΠ&6FVfvìΨ'7GWgwòΣ(8HXhxÇΘ)9IYiy\nΞ*:JZjzØ\x1B+;KÄkäøÆ,<LÖlö\ræ-=MÑmñÅß.>NÜnüåÉ/?O§oà";
const extendedGSMCharacters = "\f^{}\\[~]|€";
const convertToHashSet = function(characters) {
  const result = new Set();
  [...characters].forEach(char => {
    result.add(char);
  });
  return result;
};

const standardGsmCharacters = convertToHashSet(GSMCharacters);
const extendedGsmCharacters = convertToHashSet(extendedGSMCharacters);

const isStandardGsmChar = function(char) {
  return standardGsmCharacters.has(char);
};

const IsExtendedGsmChar = function(char) {
  return extendedGsmCharacters.has(char);
};

const IsGsmChar = function(char) {
  return standardGsmCharacters.has(char) || extendedGsmCharacters.has(char);
};

const IsGsmOnly = function(body) {
  return [...body].every(IsGsmChar);
};

const GetGsmLength = function(body) {
  if (!body) {
    return 0;
  }
  const arr = [];
  [...body].forEach(c => {
    if (isStandardGsmChar(c)) {
      arr.push(1);
    } else if (IsExtendedGsmChar(c)) {
      arr.push(2);
    } else {
      arr.push(1);
    }
  });

  return arr.reduce(function(a, b) {
    return a + b;
  });
};

const GetRequiredSegmentCount = function(body) {
  if (IsGsmOnly(body)) {
    const gsmChars = GetGsmLength(body);
    if (gsmChars <= maxSingleSegmentSMSLengthGSM) {
      return {
        segmentCount: 1,
        usedChars: gsmChars,
        totalChars: maxSingleSegmentSMSLengthGSM
      };
    } else {
      const gsmSegments =
        ((gsmChars - 1) / maxMultiSegmentSMSLengthGSM + 1) | 0;
      return {
        segmentCount: gsmSegments,
        usedChars: gsmChars,
        totalChars: gsmSegments * maxMultiSegmentSMSLengthGSM
      };
    }
  } else {
    const bodyLength = [...body].length;
    if (bodyLength <= maxSingleSegmentSMSLengthUCS2) {
      return {
        segmentCount: 1,
        usedChars: bodyLength,
        totalChars: maxSingleSegmentSMSLengthUCS2
      };
    } else {
      const ucs2Segments =
        ((bodyLength - 1) / maxMultiSegmentSMSLengthUCS2 + 1) | 0;
      return {
        segmentCount: ucs2Segments,
        usedChars: bodyLength,
        totalChars: ucs2Segments * maxMultiSegmentSMSLengthUCS2
      };
    }
  }
};
export default Vue.extend({
  props: ["message"],
  setup(props, context: any): any {
    return {
      GetRequiredSegmentCount
    };
  }
});
